import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LockIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M16.5 10.75H6.5C5.11929 10.75 4 11.8693 4 13.25V19.5C4 20.8807 5.11929 22 6.5 22H16.5C17.8807 22 19 20.8807 19 19.5V13.25C19 11.8693 17.8807 10.75 16.5 10.75Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
      />
      <path
        d="M7.75 10.75V5.75C7.75 3.625 9.375 2 11.5 2C13.625 2 15.25 3.625 15.25 5.75V10.75"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
      />
    </BaseIcon>
  ),
);

LockIcon.displayName = 'LockIcon';
